import styles from "./Menu.module.css";

const OrderedList = ({ pos,USER}) => {
  return (
    <div className={styles.orderedList}>
      <div className={styles.navItems}>
        {
          pos>1?<div className={styles.navItem}>
          <img className={styles.badgeCheckIcon} alt="" src="/badgecheck1.svg" />
          <div className={styles.navText}>Account Info</div>
        </div>:
        <div className={styles.navItem1}>
          <div className={styles.navLink}>1</div>
          <div className={styles.navText}>Account Info</div>
        </div>
        }
        <div className={styles.navCheckmarkIcon} loading="eager" alt=""/>

        {
          pos>2?<div className={styles.navItem}>
          <img className={styles.badgeCheckIcon} alt="" src="/badgecheck1.svg" />
          <div className={styles.navText}>Verify via OTP</div>
        </div>:
        <div className={styles.navItem1}>
          <div className={styles.navLink}>2</div>
          <div className={styles.navText}>Verify via OTP</div>
        </div>
        }
        { !USER &&<div className={styles.navCheckmarkIcon} loading="eager" alt=""/>}

        { !USER &&(
          pos>3?<div className={styles.navItem}>
          <img className={styles.badgeCheckIcon} alt="" src="/badgecheck1.svg" />
          <div className={styles.navText}>Generate Key</div>
        </div>:
        <div className={styles.navItem1}>
          <div className={styles.navLink}>3</div>
          <div className={styles.navText}>Generate Key</div>
        </div>)
        }
      </div>
    </div>
  );
};

export default OrderedList;
